import { onDestroy } from "svelte";
import { getProductPrices } from "./priceCalculator";
export const setFocus = (target, delay = true) => {
    let timeout;
    if (delay) {
        timeout = setTimeout(() => {
            target.focus();
        }, 800);
    }
    else {
        target.focus();
    }
    onDestroy(() => {
        if (delay) {
            clearTimeout(timeout);
        }
    });
};
export const getBorderColors = (error, empty, disabled) => {
    // let border = "ring-0 focus:ring-0"
    if (disabled)
        return "";
    let border = "mt-1 ";
    if (error && !empty)
        return `focus:ring-4 ring-2 focus:ring-Red800 ring-Red800 ${border}`;
    border += "focus:ring-2 ";
    border += empty ? "focus:ring-Violet400" : "focus:ring-Green900 outline-none";
    return `${border} ${empty ? "ring-2 ring-Yellow" : "border border-Neutral400"}`;
};
export const readCookie = (name) => {
    try {
        let cookie = {};
        document.cookie.split(";").forEach(function (el) {
            let [k, v] = el.split("=");
            cookie[k.trim()] = v;
        });
        return cookie[name];
    }
    catch (e) {
        return null;
    }
};
export const getAvaliableProducts = (data, estimation, showFixed = true, showVariable = true, showHourly = true) => {
    const products = getProductPrices(data.result, estimation);
    if (!showFixed && products.fixedProducts) {
        delete products["fixedProducts"];
    }
    if (!showVariable && products.variableProducts) {
        delete products["variableProducts"];
    }
    if (!showHourly && products.hourlyProducts) {
        delete products["hourlyProducts"];
    }
    return products;
};
export const getDefaultProductOrder = () => ["variable", "hourly", "fixed"];
export const getSummary = (context, seller, invoiceValue, facility, isMoving) => {
    var _a, _b, _c, _d, _e;
    let summary = {
        pin: context.person.socialSecurity,
        email: context.person.email,
        phone: context.person.mobile,
        firstname: context.person.firstname,
        lastname: context.person.lastname,
        deliveryAddress: context.facilityInformation.address,
        deliveryCity: context.facilityInformation.city,
        deliveryZipcode: parseInt(context.facilityInformation.zipcode),
        address: context.person.address,
        zipcode: context.person.zipcode,
        isMovingIn: isMoving ? true : false,
        city: context.person.city,
        residenceType: context.facilityInformation.residenceType,
        startDate: new Date(context.startDate.getTime() - context.startDate.getTimezoneOffset() * 60 * 1000)
            .toISOString()
            .split("T")[0],
        authority: context.facility.powerOfAttorney,
        terms: false,
        estimation: context.estimation,
        invoiceDistId: context.invoice.id,
        additionalProduct: (_a = context.additionalProducts) !== null && _a !== void 0 ? _a : [],
        product: context.selectedProductId,
        fetchPersonInfo: context.hasFetchedPersonAutomatic,
        fetchBillingInfo: context.hasFetchedPersonAutomatic && (context.person.address === context.facilityInformation.address),
        signWithQRCode: context.signWithQRCode,
    };
    if (context.facilityInformation.propertyOwner) {
        summary.propertyOwner = context.facilityInformation.propertyOwner;
    }
    if (context.facilityInformation.residenceType === "apartment") {
        if (context.facilityInformation.apartmentNumber) {
            summary.apartmentNumber = context.facilityInformation.apartmentNumber;
        }
        if (context.facilityInformation.formerResidence) {
            summary.formerResidence = context.facilityInformation.formerResidence;
        }
    }
    if ((_b = context === null || context === void 0 ? void 0 : context.companyInformation) === null || _b === void 0 ? void 0 : _b.address) {
        summary.address = (_c = context === null || context === void 0 ? void 0 : context.companyInformation) === null || _c === void 0 ? void 0 : _c.address;
        summary.zipcode = (_d = context === null || context === void 0 ? void 0 : context.companyInformation) === null || _d === void 0 ? void 0 : _d.zipcode;
        summary.city = (_e = context === null || context === void 0 ? void 0 : context.companyInformation) === null || _e === void 0 ? void 0 : _e.city;
    }
    else {
        summary.address = context.person.address;
        summary.zipcode = context.person.zipcode;
        summary.city = context.person.city;
    }
    if (seller)
        summary.seller = seller;
    if (invoiceValue)
        summary.invoiceDistValue = invoiceValue;
    if (!summary.authority && facility) {
        summary.facilityId = "735999" + facility.facilityId;
        summary.areaId = facility.areaId;
    }
    return summary;
};
export const toggleHTMLElement = (element) => {
    if (!element)
        return;
    if (element.classList.contains("invisible")) {
        element.classList.remove("invisible");
    }
    else {
        element.classList.add("invisible");
    }
};
export const decodeEntities = (encodedString) => {
    let textarea = document.createElement("textarea");
    textarea.innerHTML = encodedString;
    return textarea.value;
};
export const setJS = (content) => {
    content = decodeEntities(content);
    const scriptRegex = /<script(?:\s+[a-zA-Z]+(?:\s*=\s*(?:"[^"]*"|'[^']*'|[^>\s]+))?)*>([\s\S]*?)<\/script>/gis;
    const srcScriptRegex = /<script\s+src=(?:"([^"]*)"|'([^']*)'|([^>\s]+))[^>]*><\/script>/gis;
    let scriptContent = "";
    let externalScripts = [];
    if (content) {
        const matches = content.matchAll(scriptRegex);
        for (const match of matches) {
            scriptContent += match[1].replace(/<\/?p>/g, "") + "\n";
        }
        const srcMatches = content.matchAll(srcScriptRegex);
        for (const srcMatch of srcMatches) {
            const [, doubleQuoted, singleQuoted, unquoted] = srcMatch[0].match(/src="([^"]*)"|src='([^']*)'|src=([^>\s]+)/);
            let src = doubleQuoted || singleQuoted || unquoted;
            src = src.replace(/”|“/g, "");
            externalScripts.push(src);
        }
    }
    if (scriptContent) {
        scriptContent = scriptContent.replace(/”|“/g, '"');
        const script = document.createElement("script");
        script.innerHTML = scriptContent;
        document.body.appendChild(script);
    }
    if (externalScripts.length > 0) {
        externalScripts.forEach((src) => {
            const script = document.createElement("script");
            script.src = src;
            document.body.appendChild(script);
        });
    }
};
export const getFirstPossibleDate = (days) => {
    let firstPossibleDate = new Date(new Date().setDate(new Date().getDate() + days));
    firstPossibleDate.setHours(0, 0, 0, 0);
    return firstPossibleDate;
};
export const checkDeviceType = () => {
    const userAgent = navigator.userAgent;
    if (/Android/i.test(userAgent)) {
        return "Android";
    }
    else if (/iPhone|iPad|iPod/i.test(userAgent)) {
        return "iOS";
    }
    else if (/Windows Phone/i.test(userAgent)) {
        return "Windows Phone";
    }
    return "Desktop";
};
export const getBankIdUrl = (token) => {
    if (checkDeviceType() === "Desktop") {
        return `bankid:///?autostarttoken=${token}&redirect=null`;
    }
    return `https://app.bankid.com/?autostarttoken=${token}&redirect=null`;
};
